import { getAdvisorData } from '../../content/advisorHelper';
import CustomLink from 'components/shared/CustomLink';
import Image from 'next/image';
import styles from './RelatedAdvisorSection.module.css';

export const RelatedAdvisorSection = ({
  className,
  advisorId,
}: {
  className?: string;
  advisorId: string;
}) => {
  const advisorData = getAdvisorData(advisorId) as Record<string, unknown>;
  if (
    advisorData?.related == undefined ||
    (advisorData?.related as Array<unknown>).length < 1
  )
    return null;
  return (
    <div className={`${styles.root} u-grid${className ? ` ${className}` : ''}`}>
      <div className={styles.content}>
        <h2>Our Medical and Sports Science Advisory board</h2>
        <div className={styles['items-container']}>
          {(advisorData as Record<string, Array<string>>).related.map(
            (element, index) => {
              const relatedAdvisorData = getAdvisorData(element) as Record<
                string,
                string | React.ReactNode
              >;
              return (
                <CustomLink
                  href={`/advisors/${element}`}
                  key={index}
                  className={styles['related-element']}
                >
                  <div className={styles.image}>
                    <div className={styles['img-container']}>
                      <Image
                        fill
                        src={relatedAdvisorData.circleThumb as string}
                        alt={relatedAdvisorData.title as string}
                      />
                    </div>
                  </div>
                  <div className={styles.text}>
                    <h4>{relatedAdvisorData.title}</h4>
                    <h5>{relatedAdvisorData.subtitle}</h5>
                  </div>
                </CustomLink>
              );
            },
          )}
        </div>
      </div>
    </div>
  );
};
